import Token from '@/di/di.token'

import useDi from '../useDi'

export default function useAiPromptService() {
  const { container } = useDi()
  const service = container.get(Token.AI_PROMPT_SERVICE)
  return { service }
}
